<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />

    <form @keydown.enter.prevent="submit()">
      <!-- data provider  -->
      <div>
        <!-- title  -->
        <h2 class="mb-1">{{ $t('Peržiūra') }}</h2>
        <v-row class="mb-0 pb-0">
          <v-col v-if="!showFiles" class="pb-0" cols="12" md="12">
            <el-PDF-viewer download :file="pdfFile" />
          </v-col>
          <v-col v-if="showFiles" class="pb-0" cols="12" md="12">
            <el-simple-table :items="filesList" />
          </v-col>

          <template v-if="showCheckboxes">
            <template v-for="(checkbox, index) in formData.checkboxes">
              <v-col :key="index" class="pt-0 pb-4" cols="12" md="12">
                <el-checkbox
                  required
                  :disabled="modeReadonly"
                  notTranslated
                  :label="checkbox.text"
                  v-model="checkbox.value"
                  :validateKey="index"
                >
                </el-checkbox>
              </v-col>
            </template>

            <v-col class="pt-0 pb-4" cols="12" md="12">
              <h2 class="mb-1" style="display: flex;">{{ $t('Dokumento sudarytojas') }}</h2>
              <v-card outlined>
                <v-card-text class="pa-2">
                  <v-row>
                    <v-col><span>{{ dataProviderName }}</span><span v-if="dataRepresentitiveName">{{ ` (${dataRepresentitiveName})` }}</span></v-col>
                    <v-col style="text-align: end;"><span>{{ documentPreparedAt }}</span></v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

            <!-- SIGNATURES -->
            <v-col class="pt-0 pb-4" cols="12" md="12">
              <signatures-list
                :signatures="signatures"
                :status="formData.status"
                :inJournalType="formData.in_journal_type"
                :editMySignatures="formData.canEditSignatures"
                :mySignature="myParentSignature"
                :loadingList="pageloading"
              ></signatures-list>
            </v-col>

            <v-col class="pt-0 pb-4" cols="12" md="12">
              <v-card  outlined>
                <v-card-text class="pa-2">
                  <v-row>
                    <v-col class="pb-0" cols="12" >
                      <span><strong>{{ `${$t('Būsena')}: ` }}</strong><span :class="getStatusClass">{{ getStatus }}</span></span>
                    </v-col>
                    <v-col class="pt-1" cols="12" >
                      <span><strong>{{ `${$t('Pasirinkta dokumento kalba')}: ` }}</strong>{{ getSelectedLang }}</span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </template>
        </v-row>
      </div>
      <!-- actions  -->
      <v-card-actions v-if="showActions">
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <el-button
            v-if="showBack"
            class="mr-2"
            tile
            @click.native="back()"
            :loading="loading"
            title="Atgal"
          />
            <el-button
             v-if="!modeReadonly && !showBack"
            class="mr-2"
            tile
            @click.native="back()"
            :loading="loading"
            title="Atgal"
          />
          <el-button
            v-if="canCancelSigning"
            class="mr-1"
            title="Atšaukti pasirašymą"
            :loading="loading"
            @click.native="beforeCancel()"
            color="secondary"
            icon="atšaukti"
          />
           <el-button
            v-if="canPassToSigning"
            title="Perduoti patikrinimui"
            :loading="loading"
            @click.native="next()"
            color="primary"
            icon="pirmyn"
          />
          <v-tooltip v-if="canConfirmRepresenters" top max-width="300">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                color="primary"
                v-bind="attrs"
                v-on="on"
                class="v-btn-primary"
                :loading="loading"
                @click.native="beforeApproveRepresenters()"
                >
                <v-icon small>mdi-arrow-right</v-icon>
                {{ $t('Perduoti atstovų patikrinimui') }}
              </v-btn>
            </template>
            <div class="tooltip-text">{{ $t('Registro tvarkytojas patikrins, ar nurodyti asmenys vadovaujantis Juridinių asmenų registro duomenimis turi teisę juridinio asmens vardu pasirašyti dokumentą. Patikrinimas gali užtrukti iki 2 darbo dienų.') }}</div>
          </v-tooltip>
          <!-- <el-button
            v-if="canConfirmRepresenters"
            title="Perduoti atstovų patikrinimui"
            :loading="loading"
            @click.native="beforeApproveRepresenters()"
            color="primary"
            icon="pirmyn"
          /> -->
          <el-button
            class="mr-1"
            v-if="canRefuseToSign"
            title="Atsisakyti pasirašyti"
            :loading="loading"
            @click.native="beforeRefuse()"
            color="secondary"
            icon="atšaukti"
          />
          <template v-if="canSign">
            <el-button
              v-if="qualifiedSignatureRequired"
              title="Pasirašyti el. parašu"
              :loading="loading"
              @click.native="initElSigning()"
              color="primary"
              icon="pirmyn"
            />
            <el-button
              v-if="!qualifiedSignatureRequired"
              title="Pasirašyti"
              :loading="loading"
              @click.native="next()"
              color="primary"
              icon="pirmyn"
            />
          </template>
          <template v-if="canStamp">
            <el-button
              class="mr-1"
              title="Tęsti be spaudo"
              :loading="loading"
              @click.native="cancelStampRequired()"
              color="secondary"
            />
            <el-button
              title="Tvirtinti el. spaudu"
              :loading="loading"
              @click.native="initStamping()"
              color="primary"
              icon="pirmyn"
            />
          </template>
          <!-- status -->
           <!-- <el-button
            v-if="!modeReadonly && hasSigned && !lastToAgree"
            disabled
            title="Laukia pasirašymo"
            color="primary"
          /> -->
          <!-- <el-button
            class="mr-1"
            v-if="modeReadonly"
            disabled
            title="Pasirašyta"
            color="primary"
          /> -->
            <!-- <el-button
            v-if="modeReadonly && waitingApproval"
            disabled
            title="Laukiama patvirtinimo"
            color="primary"
          /> -->
        </v-row>
      </v-card-actions>
      <v-card-actions v-else-if="!showSigningComponent">
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <el-button
            v-if="!getProductLink"
            tile
            icon="atgal"
            @click.native="back()"
            :loading="loading"
            title="Atgal"
          />
           <el-button
            v-if="getProductLink"
            tile
            @click.native="goBack()"
            :loading="loading"
            title="Atgal"
          />
        </v-row>
      </v-card-actions>
    </form>
    <!-- modals -->
    <modal-custom
      :title="$t('Pasirašymo atšaukimas')"
      :text="$t('Ar tikrai norite atšaukti pasirašymą?')"
      trueText="Taip"
      falseText="Ne"
      :loading="loading"
      v-model="showCancelModal"
      @confirmData="confirmCancel"
    />
    <modal-custom
      :title="$t('Atsisakymas pasirašyti')"
      :text="$t('Ar tikrai norite atsisakyti pasirašyti?')"
      trueText="Taip"
      falseText="Ne"
      :loading="loading"
      v-model="showRefuseModal"
      @confirmData="confirmRefuse"
    />
    <modal-custom
      :title="$t('Perduoti atstovų patikrinimui')"
      :text="$t('Registro tvarkytojas patikrins, ar nurodyti asmenys vadovaujantis Juridinių asmenų registro duomenimis turi teisę juridinio asmens vardu pasirašyti dokumentą. Patikrinimas gali užtrukti iki 2 darbo dienų.')"
      trueText="Perduoti patikrinimui"
      falseText="Ne"
      :loading="loading"
      v-model="showApproveRepresentersModal"
      @confirmData="approveRepresenters"
    />
    <modal-sign
      :openSign="showSigningComponent"
      :objectId="getId"
      objectType="in_journal"
      @cancelSigning="cancelSigning"
      @signed="signingSuccessfull"
      @stampDecision="stampDecision"
    />
  </v-container>
</template>

<script>
import InJournalStatuses from '@/components/constants/inJournalStatus'
import userRole from '@/mixins/userRole'
import unsavedData from '@/mixins/unsavedData'
import errorNotifications from '@/mixins/errorNotifications'
import SignaturesList from '@/components/signatures/SignaturesList'
import ModalCustom from '@/components/modals/ModalCustom'
import Enums from '@/enums'
import SavitarnaMenu from '@/components/constants/savitarnaMenu.js'
import ModalSign from '@/components/modals/ModalSign.vue'

export default {
  name: 'DocumentView',
  components: {SignaturesList, ModalCustom, ModalSign},
  mixins: [userRole, unsavedData, errorNotifications],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      showApproveRepresentersModal: false,
      showCancelModal: false,
      showRefuseModal: false,
      dataProviderName: null,
      kind: null,
      dataRepresentitiveName: null,
      documentPreparedAt: null,
      pageloading: false,
      showAddPerson: false,
      loading: false,
      signatures: [],
      selectedSignatureId: null,
      bilingual: null,
      showSigningComponent: false,
      stampRequired: false,
      formData: {
        status: '',
        confirm: false,
        read_understood: false,
        confirm_data: false,
        calculation_procedure: false,
      },
      files: [],
      pdfFile: {},
      showEditSignaturesModal: false,
      additionalData: {
        kind: this.kind,
        in_journal_type: null
      },
      myParentSignature: {},
    }
  },
  computed: {
    showEditSignatures(){
      return this.formData.canEditSignatures && this.signatures.length > 1
    },
    canStamp() {
      return this.formData.buttons.stamp;
    },
    getSelectedLang(){
      let lang = this.$i18n.locale === 'lt' ? Enums.bilingualMandate.lt : Enums.bilingualMandate.en
      return lang[this.bilingual]
    },
    getStatus(){
      let statuses = this.$i18n.locale === 'lt' ? Enums.journalType.lt : Enums.journalType.en
      return statuses[this.formData.status]
    },
    getStatusClass(){
      return this.formData.status == InJournalStatuses.ATSAUKTAS ? 'text-red' : ''
    },
    canCancelSigning(){
      return this.formData.buttons?.cancelSigning
    },
    canPassToSigning(){
      return this.formData.buttons?.passToSigning
    },
    canPassToRepresenterConfirm(){
      return this.formData.buttons?.passToRepresenterConfirm
    },
    canConfirmRepresenters(){
      return this.formData.buttons?.confirmRepresenters
    },
    canSign(){
      return this.formData.buttons?.sign
    },
    canRefuseToSign(){
      return this.formData.buttons?.refuseToSign
    },
    kindPP(){
      return this.kind == 'PP' || false
    },
    toBasket(){
      return this.formData.buttons?.afterSignBasket
    },
    lastToAgree(){
      return this.formData.is_last_to_agree
    },
    canAgree(){
      return this.formData.can_agree
    },
    waitingApproval(){
      return (this.formData.status == "806" || this.formData.status == "809")
    },
    hasSigned(){
      return this.formData.has_signed
    },
    showFiles() {
      return this.files && Object.keys(this.files).length != 0
    },
    showCheckboxes() {
      let show = [801, 804, 806, 807, 809, 810, 811, 814]
      return show.includes(this.formData.status)
      // return this.formData.status == '806' || this.formData.status == "809"
    },
    showActions() {
      let show = [801, 804, 806, 807, 809, 810, 811, 814]
      // return this.formData.status == '806' || this.formData.status == "809"
       return show.includes(this.formData.status) && !this.showSigningComponent
    },
    getConfirmText() {
      return this.notificationText('000035')
    },
    getReadUnderstoodText() {
      return this.notificationText('000036')
    },
    getConfirmDataText() {
      return this.notificationText('000037')
    },
    getCalculationProcedureText() {
      return this.notificationText('000038')
    },
    getProductLink() {
      return this.$route.params.productLink || null
    },
    getId() {
      return this.$route.params.id || null
    },
    previewRoute() {
      return `in-journals/${this.getId}/preview`
    },
    getMainUrl() {
      return `in-journals/${this.getId}`
    },
    modeReadonly() {
      return this.formData.final
    },
    filesList() {
      let arrOfFiles = []
      this.files.map((file) => {
        let fileObj = {}
        fileObj.fileData = file.file.file
        fileObj.title = file.original_filename
        arrOfFiles.push(fileObj)
      })
      return arrOfFiles
    },
    showBack() {
      return this.formData.status == '804' || this.modeReadonly
    },
  },
  created() {
    this.getData()
  },
  methods: {
    stampDecision(decision) {
      this.stampRequired = decision
    },
    cancelStampRequired() {
      this.pageloading = true
      this.$axios
        .post(`/gosign/cancel-stamping/${this.getId}`)
        .then((res) => {
          if (res.data.toBasket) {
            window.location.href =  process.env.VUE_APP_BASKET_URL
          } else {
            let link = SavitarnaMenu.MANO_DOKUMENTAI
            window.location.href = link
            this.showSigningComponent = false
          }
        })
        .catch((err) => {
          if(err.response.status === 404){
            return this.$router.push({ name: 'sav404' })
          } else {
            this.$root.$emit('DATA_ERROR', err.response.data.message)
          }
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    goBack(){
      const url = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}services.do?showValidOnly=true&persist=new`
      window.location.href = url
      // window.history.back();
    },
    beforeApproveRepresenters() {
      this.showApproveRepresentersModal = true;
    },
    approveRepresenters() {
      this.loading = true
      this.pageloading = true
      this.$axios
        .post(`/in-journals/${this.getId}/signatures/confirm`)
        .then((res) => {
            let link = SavitarnaMenu.MANO_DOKUMENTAI
            window.location.href = link
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
          this.pageloading = false
          this.loading = false
        })
    },

    initElSigning() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.showSigningComponent = true
        } else {
          this.$root.$emit('FORMAT_ERROR_STEP')
        }
      })
    },

    initStamping() {
      this.showSigningComponent = true
    },

    cancelSigning() {
      this.showSigningComponent = false
    },

    signingSuccessfull(data) {
      this.redirectToBasket(data.toBasket || false)
      this.showSigningComponent = false;
    },

    redirectToBasket(toBasket) {
      if (
        (this.toBasket && !this.stampRequired)
        || toBasket
      ) {
        window.location.href =  process.env.VUE_APP_BASKET_URL
        return;
      }
      this.formData = {};
      this.pdfFile = {};
      return this.getData()
    },

    next() {
      this.saveData()
    },
    back() {
      this.$router.go(-1)
    },
    getPdfFile() {
      this.pageloading = true
      this.$axios
        .get(this.previewRoute)
        .then((res) => {
          if (res.data.files) {
            this.files = res.data.files
          } else {
            this.pdfFile = res.data
            this.pdfFile.original_filename = 'Peržiūra.pdf'
          }
        })
        .catch((err) => {
          if(err.response.status === 404){
            return this.$router.push({ name: 'sav404' })
          } else {
            this.$root.$emit('DATA_ERROR', err.response.data.message)
          }
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    checkIfConfirm() {
      // this.formData.final =
      //   this.formData.confirm &&
      //   this.formData.read_understood &&
      //   this.formData.confirm_data &&
      //   (this.formData.is_last_to_agree ?
      //   this.formData.calculation_procedure : true)
      this.formData.final = this.formData.has_signed
    },
    getData() {
      if (this.getId) {
        this.getPdfFile()
        this.pageloading = true

        this.$axios
          .get(this.getMainUrl)
          .then((res) => {
            this.formData = res.data.inJournal.agreements
            this.kind = res.data.inJournal.kind
            this.additionalData.in_journal_type = res.data.inJournal.in_journal_type
            this.formData.in_journal_type = res.data.inJournal.in_journal_type
            this.bilingual = res.data.inJournal.bilingual
            this.dataProviderName = res.data.inJournal.data_provider.fullname
            this.dataRepresentitiveName = res.data.inJournal.data_provider.representitive_fullname
            this.documentPreparedAt = res.data.inJournal.document_prepared_at
            this.signatures = res.data.inJournal.signatures
            this.formData.can_agree = res.data.inJournal.can_agree
            this.checkIfConfirm()
            this.formData.status = res.data.inJournal.status
            this.formData.canEditSignatures = res.data.inJournal.canEditSignatures
            this.initialForm()
            this.myParentSignature = res.data.inJournal.myParentSignature
            this.qualifiedSignatureRequired = res.data.inJournal.signature_required
          })
          .catch((err) => {
            // if(err.response.status === 404){return}
            this.$root.$emit('DATA_ERROR', err.response.data.message)
          })
          .finally(() => {
            this.pageloading = false
          })
      }
    },
    beforeCancel(){
      this.showCancelModal = true
    },
    beforeRefuse(){
      this.showRefuseModal = true
    },
    confirmRefuse() {
      this.refuse()
    },
    confirmCancel(){
      this.cancel()
    },
    cancel(){
      this.loading = true
      this.pageloading = true
      let formData = { ...this.formData }
      let url = `in-journals/${this.getId}/cancel`
      this.$axios.post(url, formData)
      .then((res) => {
        this.$root.$emit('DATA_OK_STEP')
        // then
        this.initialForm()
        this.formData = {};
        this.pdfFile = {};
        return this.getData()
      }).catch((err) => {
        this.$root.$emit('DATA_ERROR', err)
      }).finally(() => {
        this.showCancelModal = false
        this.loading = false
        this.pageloading = false
      })
    },
    refuse(){
      this.loading = true
      this.pageloading = true
      let formData = { ...this.formData }
      let url = `in-journals/${this.getId}/refuse`
      this.$axios.post(url, formData)
      .then((res) => {
        this.$root.$emit('DATA_OK_STEP')
        // then
        this.initialForm()
        this.formData = {};
        this.pdfFile = {};
        return this.getData()
      }).catch((err) => {
        this.$root.$emit('DATA_ERROR', err)
      }).finally(() => {
        this.showRefuseModal = false
        this.loading = false
        this.pageloading = false
      })
    },
saveData() {
  this.$validator.validateAll().then((res) => {
    if (res) {
      this.loading = true
      this.pageloading = true
      let formData = { ...this.formData }
      Object.keys(this.formData.checkboxes).map((key) => {
        formData[key] = this.formData.checkboxes[key].value
      })
      let url = `in-journals/${this.getId}/agreements`
      this.$axios
        .post(url, formData)
        .then((res) => {
            this.redirectToBasket()
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    } else {
      this.$root.$emit('FORMAT_ERROR_STEP')
    }
  })
},
  },
}
</script>
<style lang="scss" scoped></style>
